/**
 * Created by RKL on 13/08/2015.
 */
define('mbAnaResGrDetailView',[
  'module',
  'mbAnaResGrCreateEditLayoutView',
  'underscore',
  'marionette',
  'template!mbAnaResGrDetailTabTpl'
], function (
  module,
  CreateEditLayoutView,
  _,
  Marionette,
  viewTpl
) {
  'use strict';

  var MbAnaResGrDetailView = Marionette.ItemView.extend({
    template: viewTpl,

    modelEvents: {
      change: 'render'
    },

    events: {
      'click .js-edit': '_onEdit'
    },

    serializeData: function () {
      var templateData = this.model.toJSON();
      templateData.viewLess = this.model.get('secId');
      return templateData;
    },

    _onEdit: function() {
      var createEditView = new CreateEditLayoutView({
        mbanaresgrModel: this.model
      });
      createEditView.show({
        title: _.i18n('customers.edit')
      });
    }

  });

  module.exports = MbAnaResGrDetailView;
});
